import { z } from 'zod';
import { AllCharLabelSchema, SearchStringSchema, SubjectSchema } from '../common/schemas';
import { DBLegacyExamExamIdSchema } from '../legacyExams/schemas';
import {
  DBLegacyTopicGroupGroupIdSchema,
  LegacyTopicGroupIdSchema,
} from '../legacyTopicGroups/schemas';

/**
 * Shared & Helper Schemas
 */

/**
 * DB Schemas
 */
export const DBLegacyTopicSubjectSchema = SubjectSchema;
export const DBLegacyTopicTopicIdSchema = z.string().regex(/^[a-z0-9]{1,16}[0-9]{1,4}$/);
export const DBLegacyTopicExamsSchema = z.record(
  z.lazy(() => DBLegacyExamExamIdSchema),
  z.object({}).strict()
);
export const DBLegacyTopicLabelSchema = AllCharLabelSchema.min(1).max(64);
export const DBLegacyTopicSearchStrSchema = SearchStringSchema;
export const DBLegacyTopicTopicGroupSchema = z.lazy(() => DBLegacyTopicGroupGroupIdSchema);

export const DBLegacyTopicSchema = z.object({
  subject: DBLegacyTopicSubjectSchema,
  topicId: DBLegacyTopicTopicIdSchema,
  // Optional to allow removal of a specific exam
  exams: DBLegacyTopicExamsSchema.optional(),
  label: DBLegacyTopicLabelSchema,
  searchStr: DBLegacyTopicSearchStrSchema,
  topicGroup: DBLegacyTopicTopicGroupSchema,
});

/**
 * Client Schemas
 */

export const LegacyTopicIdSchema = z.string().brand<'LegacyTopicId'>();
export const LegacyTopicSubjectSchema = DBLegacyTopicSubjectSchema;
export const LegacyTopicCodeSchema = DBLegacyTopicTopicIdSchema;
export const LegacyTopicLabelSchema = DBLegacyTopicLabelSchema;
export const LegacyTopicSearchStrSchema = DBLegacyTopicSearchStrSchema;
export const LegacyTopicExamCodesSchema = z.array(z.lazy(() => DBLegacyExamExamIdSchema));
export const LegacyTopicTopicGroupIdSchema = z.lazy(() => LegacyTopicGroupIdSchema);
export const LegacyTopicTopicGroupCodeSchema = DBLegacyTopicTopicGroupSchema;

export const LegacyTopicSchema = z.object({
  id: LegacyTopicIdSchema.meta({ title: 'Topic ID' }),
  subject: LegacyTopicSubjectSchema.meta({ title: 'Subject' }),
  code: LegacyTopicCodeSchema.meta({ title: 'Topic code' }),
  examCodes: LegacyTopicExamCodesSchema.default([]),
  label: LegacyTopicLabelSchema.meta({ title: 'Label' }),
  searchStr: LegacyTopicSearchStrSchema.default(''),
  topicGroupId: LegacyTopicTopicGroupIdSchema.meta({ title: 'Topic group' }),
  topicGroupCode: LegacyTopicTopicGroupCodeSchema.meta({ title: 'Topic group code' }),
});
